import { Button } from "@pepperstone/pepper-ui-kit";
import { ReactNode } from "react";

import { useIsRtl } from "../hooks/useIsRtl";

export type OptionsProps = {
  children: ReactNode;
  isMobileVersion: boolean;
  toggleOptionsVisibility: () => void;
};

export const OptionsList = ({
  children,
  isMobileVersion,
  toggleOptionsVisibility,
}: OptionsProps) => {
  const isRtl = useIsRtl();
  return (
    <div>
      {isMobileVersion && (
        <div className="flex pb-6 ps-4 pt-2">
          <Button
            aria-label="Back"
            icon={isRtl ? "arrow-right" : "arrow-left"}
            type="button"
            variant="ps-btn-transparent"
            theme="light"
            onClick={toggleOptionsVisibility}
          />
        </div>
      )}
      <ul className="flex flex-col gap-1 pe-1.5 ps-4">{children}</ul>
    </div>
  );
};
